// contains selection based selectors(selector funs) for user from state object
// a selector fun is used to extract off value from state obje
export const selectCurrentUser = (state) => state.user.currentUser;
